import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="rysl-footer">
      <div className="rysl-footer-container">
        
        {/* Ecosystem Highlight Section */}
        <div className="rysl-ecosystem-highlight">
          <h2>🎸 The RYSL Universe 🎸</h2>
          <p>Your complete ecosystem for rocking sobriety in every area of life. How do you rock sober?</p>
          
          <div className="rysl-ecosystem-grid">
            {/* Main Website */}
            <a 
              href="https://rockinyoursoberlife.com" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="rysl-ecosystem-card"
            >
              <div className="rysl-ecosystem-card-icon">🏠</div>
              <h3>Main Hub</h3>
              <p>Resources, blog, community & inspiration</p>
            </a>
            
            {/* RYSL Shop */}
            <a 
              href="https://ryslshop.com" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="rysl-ecosystem-card"
            >
              <div className="rysl-ecosystem-card-icon">🛍️</div>
              <h3>RYSL Shop</h3>
              <p>Sober lifestyle merch & gear</p>
            </a>
            
            {/* Sips Directory */}
            <a 
              href="https://sipsdirectory.com" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="rysl-ecosystem-card"
            >
              <div className="rysl-ecosystem-card-icon">🍹</div>
              <h3>SipsDirectory</h3>
              <p>Find mocktails & NA drinks near you</p>
            </a>
            
            {/* Member Portal - Coming Soon */}
            <div className="rysl-ecosystem-card coming-soon">
              <div className="rysl-ecosystem-card-icon">🚀</div>
              <h3>
                Member Portal 
                <span className="coming-soon-badge">Soon</span>
              </h3>
              <p>Exclusive courses, community & tools</p>
            </div>
          </div>
        </div>

        {/* Main Footer Content */}
        <div className="rysl-footer-grid">
          {/* Logo & About */}
          <div className="rysl-footer-section">
            {/* Logo - Replace with your actual logo path */}
            <div className="rysl-logo-container">
              <img 
                src="/assets/rysl-logo.png" 
                alt="Rockin' Your Sober Life Logo" 
                className="rysl-footer-logo"
              />
            </div>
            
            <h3>Connect With Us</h3>
            <p>Join thousands living their best sober lives. Get weekly inspiration, mocktail recipes, and real talk about sobriety.</p>
            
            <div className="rysl-social-links">
              {/* Facebook */}
              <a 
                href="https://www.facebook.com/profile.php?id=61573567078818" 
                target="_blank" 
                rel="noopener noreferrer" 
                aria-label="Facebook"
              >
                <svg width="20" height="20" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                </svg>
              </a>
              
              {/* Instagram */}
              <a 
                href="https://instagram.com/rockinyoursoberlife" 
                target="_blank" 
                rel="noopener noreferrer" 
                aria-label="Instagram"
              >
                <svg width="20" height="20" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
                </svg>
              </a>
              
              {/* TikTok */}
              <a 
                href="https://tiktok.com/@ryslofficial" 
                target="_blank" 
                rel="noopener noreferrer" 
                aria-label="TikTok"
              >
                <svg width="20" height="20" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z"/>
                </svg>
              </a>
              
              {/* YouTube */}
              <a 
                href="https://youtube.com/@rockyoursoberlife" 
                target="_blank" 
                rel="noopener noreferrer" 
                aria-label="YouTube"
              >
                <svg width="20" height="20" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
                </svg>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div className="rysl-footer-section">
            <h3>Quick Links</h3>
            <ul className="rysl-footer-links">
              <li><a href="https://rockinyoursoberlife.com">Rockin' Your Sober Life Home</a></li>
              <li><a href="https://rockinyoursoberlife.com/about">About Us</a></li>
              <li><a href="https://rockinyoursoberlife.com/blog">Blog</a></li>
              {/*<li><a href="https://rockinyoursoberlife.com/resources">Free Resources</a></li>*/}
              <li><a href="https://rockinyoursoberlife.com/contact">Get in Touch</a></li>
            </ul>
          </div>

          {/* Products */}
          <div className="rysl-footer-section">
            <h3>Products</h3>
            <ul className="rysl-footer-links">
              <li><a href="https://ryslshop.com/products/how-to-rock-your-sober-life-e-book"> How to Rock Your Sober Life Book</a></li>
              {/*<li><a href="https://rockinyoursoberlife.com/course">Online Courses</a></li>
              <li><a href="https://rockinyoursoberlife.com/coaching">1-on-1 Coaching</a></li>*/}
              <li><a href="https://ryslmixmaster.com">MixMaster Studio</a></li>
              <li><a href="https://sipsdirectory.com">SIPS Directory</a></li>
            </ul>
          </div>

          {/* Contact */}
          <div className="rysl-footer-section">
            <h3>Get In Touch</h3>
            <p>
              <strong>Email:</strong><br />
              <a href="mailto:shelley@rockinyoursoberlife.com">
                shelley@rockinyoursoberlife.com
              </a>
            </p>
            <div className="rysl-cta-box">
              <strong>Ready to rock your sober life?</strong><br />
              Join our community and get started today!
            </div>
          </div>
        </div>

        {/* Footer Bottom */}
        <div className="rysl-footer-bottom">
          <div className="rysl-footer-legal">
            <a href="/privacy-policy.html" target="_blank" rel="noopener noreferrer">Privacy Policy</a>
            <span>|</span>
            <a href="/terms-of-service.html" target="_blank" rel="noopener noreferrer">Terms of Service</a>
            <span>|</span>
            <a href="https://rockinyoursoberlife.com/contact">Contact Us</a>
          </div>
          <p className="rysl-footer-copyright">
            &copy; 2026 Rockin' Your Sober Life. All rights reserved.
          </p>
          <p className="rysl-footer-tagline">
            🎸 Sobriety isn't about giving up—it's about gaining everything. How do you rock sober? 🎸
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
